const IntrantCategory = {
    SEED: 'Semence',
    OTHER: 'Autre',
    PESTICID: 'Pesticide',
    FERTILIZER: "Engrais"
};

export default IntrantCategory;